<template>
  <section id="contact" class="h25-section alt map-section">
    <div class="h25-container">
      <div class="h25-sec-hd center">
        <div class="label">Cooperation</div><h2>诚邀合作伙伴</h2>
      </div>
      <p class="invite-desc">我们提供技术与产品，你带客户与场景，共同完成政企AI落地闭环。</p>
      <p class="modes">合作模式：<strong>产品代理</strong> · <strong>白标合作</strong> · <strong>项目联合</strong></p>
      <div class="map-wrapper">
        <div id="h25-amap" style="width:100%;height:100%"></div>
        <div class="map-overlay" @click="recenter">
          <div class="mo-name">深圳市创势互联科技有限公司</div>
          <div class="mo-addr" v-if="info.address">{{ info.address }}</div>
          <div class="mo-name" v-if="info.hotline">联系电话：{{ info.hotline }}</div>
          <div class="mo-name" v-if="info.email">电子邮箱：{{ info.email }}</div>
          <div class="mo-badge">📍 公司总部</div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import AMapLoader from '@amap/amap-jsapi-loader'
import axios from 'axios'
export default {
  name:'ContactSection',
  data(){return{map:null,marker:null,centerPos:[114.230360,22.686580],info:{}}},
  mounted(){ this.fetchInfo(); this.initMap() },
  destroyed(){ if(this.map){this.map.destroy();this.map=null} },
  methods:{
    fetchInfo(){
      axios.get('/api/csWeb/info').then(res=>{ this.info=res.data||{} }).catch(()=>{})
    },
    initMap(){
      const pos=this.centerPos
      AMapLoader.load({ key:'94fde07e5245897c28478b892d62235f', version:'2.0' }).then(AMap=>{
        this.map=new AMap.Map('h25-amap',{ viewMode:'3D', zoom:16, center:pos })
        this.marker=new AMap.Marker({
          position:new AMap.LngLat(pos[0],pos[1]),
          title:'创势互联科技有限公司',
          content:'<div style="width:300px;height:80px;background:#fff;padding:4px"><img style="float:left;width:100px;height:100%" src="'+require('@/assets/newImages/gate.jpg')+'" /><span style="float:left;color:#000;font-size:14px;margin:4px">大运软件小镇39栋3楼</span></div><img src="'+require('@/assets/images/mark_bs2.png')+'" />',
          offset:new AMap.Pixel(-16,-14)
        })
        this.map.add(this.marker)
      }).catch(()=>{})
    },
    recenter(){
      if(this.map&&this.marker){
        this.map.setCenter(this.centerPos)
        this.map.setZoom(16)
      }
    }
  }
}
</script>
<style scoped>
.map-section{text-align:center}
.invite-desc{font-size:16px;color:var(--h25-text2);max-width:640px;margin:0 auto 18px;line-height:1.8}
.modes{text-align:center;font-size:14px;color:var(--h25-muted);margin-bottom:36px}
.modes strong{color:var(--h25-text)}
.map-wrapper{position:relative;width:100%;max-width:960px;height:420px;margin:0 auto;border-radius:var(--h25-radius);overflow:hidden;border:1px solid var(--h25-border);box-shadow:0 2px 16px rgba(0,0,0,.04)}
.map-overlay{position:absolute;top:16px;left:16px;background:var(--h25-white);padding:12px 18px;border-radius:var(--h25-radius);box-shadow:0 2px 8px rgba(0,0,0,.08);text-align:left;max-width:280px;z-index:2;cursor:pointer;transition:box-shadow .2s}
.map-overlay:hover{box-shadow:0 4px 16px rgba(0,0,0,.15)}
.mo-name{font-size:14px;font-weight:700;color:var(--h25-text);margin-bottom:4px}
.mo-addr{font-size:12px;color:var(--h25-muted);line-height:1.6}
.mo-badge{display:inline-block;margin-top:6px;padding:3px 10px;background:var(--h25-accent);color:var(--h25-white);border-radius:10px;font-size:10px;font-weight:600}
@media(max-width:768px){.map-wrapper{height:300px}.map-overlay{top:8px;left:8px;max-width:200px;padding:8px 12px}}
</style>
